import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'measure'
})
export class MeasurePipe implements PipeTransform {

  transform(value: any, measure: string): any {
    return value ? `${value} ${measure}` : 'Indefinido';
  }

}
